import { LeagueResultModel } from "@/models/LeagueResultModels";
import { BaseRepo } from "./base/BaseRepo";
import { createLeagueResultMigrationManager } from "@/utils/migrations";


// src/repos/LeaguesRepo.ts
/**
 * Repository for models in the leagues collection
 */
export class LeagueResultsRepo extends BaseRepo<LeagueResultModel> {
    protected collectionName = 'leagueResults';
    protected cacheKeyPrefix = 'leagueResult_';

    constructor() {
        super();
        this.setupMigrations(createLeagueResultMigrationManager());
    }
}